import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';

const FieldAdmin = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'login-as-admin-form-admin',
    defaultMessage: 'Administrator'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField<string>({name: 'admin'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      placeholder={placeholder}
    />
  );
};

export default FieldAdmin;
